<template>
  <span :id="id">
    <slot/>
  </span>
</template>

<script>
    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css';

    export default {
        props: {
            id: {
                type: String,
                default() {
                    return `tooltip-${this._uid}`;
                },
            },
            text: String,
            position: {
                type: String,
                default() {
                    return 'bottom';
                },
            },
            show: {
                type: Boolean,
                default() {
                    return true;
                },
            },
            animation: {
                type: String,
                default() {
                    return 'fade';
                }
            },
            allowHTML: {
                type: Boolean,
                default() {
                    return false;
                },
            },
        },
        mounted() {
            if (!this.show) {
                return;
            }

            tippy(`#${this.id}`, {
                content: this.text,
                placement: this.position,
                animation: this.animation,
                allowHTML: this.allowHTML,
            });
        }
    }
</script>

<style>
    .tippy-box {
        font-size: 12px;
        word-break: break-all;
    }
</style>
